import type {SafeHTMLString} from '@github-ui/safe-html'
import type {ColorName} from '@github-ui/use-named-color'

export type NewSingleSelectOption = {
  color: ColorName
  name: string
  description: string
}

export type PersistedSingleSelectOption = NewSingleSelectOption & {
  id: string
  nameHtml: SafeHTMLString
  descriptionHtml: SafeHTMLString
}

export type SingleSelectOptionWithId = NewSingleSelectOption & {id: string}

export type SingleSelectOption = NewSingleSelectOption | PersistedSingleSelectOption

export const emptySingleSelectOption: SingleSelectOption = {color: 'GRAY', description: '', name: ''}
